// API URLs - directly from .env
export const INTERVIEW_AGENT_BASE_URL = import.meta.env.VITE_INTERVIEW_AGENT_BASE_URL;
export const RECRUITMENT_AGENT_BASE_URL = import.meta.env.VITE_RECRUITMENT_AGENT_BASE_URL;
export const WS_URL = import.meta.env.VITE_WS_URL;

// App Configuration - directly from .env
export const APP_NAME = import.meta.env.VITE_APP_NAME;
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;

// Feature Flags - directly from .env
export const ENABLE_FACE_DETECTION = import.meta.env.VITE_ENABLE_FACE_DETECTION;
export const ENABLE_SCREEN_RECORDING = import.meta.env.VITE_ENABLE_SCREEN_RECORDING;

// Debug settings - directly from .env
export const DEBUG_MODE = import.meta.env.VITE_DEBUG_MODE;
export const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL;
